import { Container } from 'react-bootstrap';
import VideoComponent from './VideoComponent';

const VideoComponentDemo = () => {
  return (
    <Container>
      <h4>Video Component</h4>
      <VideoComponent embedLink={'https://www.youtube.com/embed/qE5pwDEvxGk'} />
    </Container>
  );
};

export default VideoComponentDemo;
